require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-mx-update-boletines-iiscal.json") })
        }
      }, "path---es-mx-update-boletines-iiscal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-mx-update-boletines-iiscal!./.cache/json/es-mx-update-boletines-iiscal.json
// module id = 917
// module chunks = 231608221292675